import { useMemo, useState } from 'react';
import { buildCentreOptions } from './CbtCentreSelect';

const useCbtVenueDropdown = ({ locations, centres }) => {
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedCenter, setSelectedCenter] = useState(null);

  const stateOptions = useMemo(
    () =>
      Object.keys(locations ?? {}).map((state) => ({
        label: state,
        value: state
      })),
    [locations]
  );

  const cityOptions = useMemo(() => {
    if (!selectedState) return [];
    return (locations?.[selectedState.value] ?? []).map((city) => ({
      label: city,
      value: city
    }));
  }, [locations, selectedState]);

  const centerOptions = useMemo(
    () => buildCentreOptions(centres, selectedCity),
    [centres, selectedCity]
  );

  return {
    stateOptions,
    cityOptions,
    centerOptions,
    selectedState,
    selectedCity,
    selectedCenter,
    setSelectedState: (option) => {
      setSelectedState(option);
      setSelectedCity(null);
      setSelectedCenter(null);
    },
    setSelectedCity: (option) => {
      setSelectedCity(option);
      setSelectedCenter(null);
    },
    setSelectedCenter
  };
};

export default useCbtVenueDropdown;
